import React, { useState} from "react";
import {
  BarChart, Bar, LineChart, Line, AreaChart, Area,
  PieChart, Pie, Cell,
  XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer,
} from "recharts";
import placeholderImg from "../images/design.png";
// ─── Theme ───────────────────────────────────────────────────────────────────
const T = {
  bg: "#0b0f1a", sidebar: "#0f172a", card: "#0c1220", cardAlt: "#111827",
  accent: "#2185ff", accentDim: "rgba(13,102,211,0.15)", accentBorder: "rgba(28,139,250,0.35)",
  border: "rgba(255,255,255,0.06)", borderMid: "rgba(255,255,255,0.10)",
  text: "#e5e7eb", muted: "#b3b5b9", faint: "#888d97",
  orange: "#f97316", red: "#ef4444", blue: "#60a5fa", yellow: "#fbbf24",
};

// ─── Data ─────────────────────────────────────────────────────────────────────
const DASHBOARD_STATS = [
  { label: "Revenue",    value: "$7,825",  pct: "+22%",  up: true  },
  { label: "Orders",     value: "920",     pct: "–25%",  up: false },
  //{ label: "Visitors",   value: "15.5K",   pct: "+49%",  up: true  },
  //{ label: "Conversion", value: "28%",     pct: "+1.9%", up: true  },
   { label: "Net Profit",  value: "28%",     pct: "+12%",  up: true  },
];
const PRODUCT_STATS = [
  { label: "Revenue",     value: "$75,620", pct: "+22%",  up: true  },
  { label: "Orders Paid", value: "520",     pct: "+5.7%", up: true  },
  { label: "Refunds",     value: "7,283",   pct: "18%",   up: false },
  { label: "Net Profit",  value: "28%",     pct: "+12%",  up: true  },
];
const BAR_DATA = [
  {d:"20",v:3200},{d:"22",v:4100},{d:"24",v:2800},{d:"26",v:5200},
  {d:"28",v:3600},{d:"30",v:4800},{d:"02",v:8200,hot:true},{d:"04",v:3100},
  {d:"06",v:5800},{d:"08",v:4200},{d:"10",v:6100},{d:"12",v:3900},
  {d:"14",v:5500},{d:"16",v:4700},
];
const LINE_DATA = [
  {d:"16",v:1100},{d:"18",v:1450},{d:"20",v:1350},{d:"22",v:1600},
  {d:"24",v:2000},{d:"26",v:2500},{d:"28",v:2100},{d:"30",v:1800},
  {d:"02",v:2500},{d:"04",v:2200},{d:"06",v:2700},{d:"08",v:2400},{d:"10",v:2600},
];
const DEVICE_DATA = [
  { name:"Desktop", value:64.2, color:"#60a5fa", amt:"$830.03" },
  { name:"Tablet",  value:15.3, color:"#22c55e", amt:"$550.81" },
  { name:"Mobile",  value:48.6, color:"#ef4444", amt:"$755.75" },
  { name:"Unknown", value:8.6,  color:"#f97316", amt:"$150.84" },
];
const BESTSELLERS = [
  { name:"Deco accessory",   price:"$21.19", sold:409, profit:"$1,822.87" },
  { name:"Pottery Vase",     price:"$14.18", sold:396, profit:"$8,545.25" },
  { name:"Rose Holdback",    price:"$18.15", sold:243, profit:"$7,287.01" },
  { name:"Flowering Cactus", price:"$74.16", sold:636, profit:"$9,325.47" },
];
const FORECAST = [
  { label:"Revenue",    val:"+24.2%", up:true  },
  { label:"Net Profit", val:"–2.5%",  up:false },
  { label:"Orders",     val:"+32.8%", up:true  },
  { label:"Visitors",   val:"+60%",   up:true  },
];
const LATEST_ORDERS = [
  { product:"Analog Table Clock",  qty:"×2", date:"Feb 5, 2020",  rev:"$253.82", profit:"$60.76",  status:"Pending"   },
  { product:"Basket with handles", qty:"×3", date:"Sep 8, 2020",  rev:"$556.24", profit:"$66.41",  status:"Shipping"  },
  { product:"Flower vase",         qty:"×3", date:"Dec 21, 2020", rev:"$115.26", profit:"$95.66",  status:"Refund"    },
  { product:"Deco accessory",      qty:"×2", date:"Aug 13, 2020", rev:"$675.51", profit:"$84.80",  status:"Completed" },
  { product:"Pottery Vase",        qty:"×2", date:"May 8, 2020",  rev:"$910.71", profit:"$46.52",  status:"Shipping"  },
  { product:"Rose Holdback",       qty:"×4", date:"Nov 15, 2020", rev:"$897.90", profit:"$81.54",  status:"Completed" },
  { product:"Table Lamp",          qty:"×4", date:"Sep 14, 2020", rev:"$563.43", profit:"$17.46",  status:"Pending"   },
  { product:"Wall Clock",          qty:"×3", date:"May 15, 2020", rev:"$883.96", profit:"$43.08",  status:"Refund"    },
  { product:"Flowering Cactus",    qty:"×2", date:"Sep 2, 2020",  rev:"$162.15", profit:"$86.65",  status:"Completed" },
  { product:"Shell Collection",    qty:"×4", date:"Sep 20, 2020", rev:"$378.34", profit:"$49.08",  status:"Completed" },
];
const ORDERS_TABLE = [
  { id:"#53200002", items:"8 Items", date:"Jan 10, 2020", customer:"Ronald Jones",    rev:"$253.82", profit:"$60.76",  status:"Pending"   },
  { id:"#53200003", items:"5 Items", date:"Sep 4, 2020",  customer:"Jacob Mckinney", rev:"$556.24", profit:"$66.41",  status:"Shipping"  },
  { id:"#53200004", items:"7 Items", date:"Aug 30, 2020", customer:"Randall Murphy", rev:"$115.26", profit:"$95.66",  status:"Refund"    },
  { id:"#53200005", items:"3 Items", date:"Aug 29, 2020", customer:"Philip Webb",    rev:"$675.51", profit:"$84.80",  status:"Completed" },
  { id:"#53200006", items:"4 Items", date:"Dec 26, 2020", customer:"Arthur Bell",    rev:"$910.71", profit:"$46.52",  status:"Shipping"  },
  { id:"#53200007", items:"5 Items", date:"Apr 27, 2020", customer:"Gregory Nguyen", rev:"$897.90", profit:"$81.54",  status:"Completed" },
  { id:"#53200008", items:"3 Items", date:"May 5, 2020",  customer:"Soham Henry",    rev:"$563.43", profit:"$17.46",  status:"Pending"   },
  { id:"#53200009", items:"5 Items", date:"Oct 15, 2020", customer:"Jenny Hawkins",  rev:"$883.96", profit:"$43.08",  status:"Refund"    },
  { id:"#53200010", items:"4 Items", date:"Jul 12, 2020", customer:"Diane Cooper",   rev:"$162.15", profit:"$86.65",  status:"Completed" },
  { id:"#53200012", items:"2 Items", date:"Jun 28, 2020", customer:"Max Williamson", rev:"$378.34", profit:"$49.08",  status:"Completed" },
];
const PRODUCT_ORDERS = [
  { id:"#32000200", customer:"Priscilla Warren",  qty:2, date:"Jan 10, 2020", rev:"$253.82", profit:"$60.76",  status:"Completed" },
  { id:"#32000200", customer:"Tanya Wilson",      qty:1, date:"Sep 4, 2020",  rev:"$556.24", profit:"$66.41",  status:"Completed" },
  { id:"#32000200", customer:"Theresa Alexander", qty:3, date:"Aug 30, 2020", rev:"$115.26", profit:"$95.66",  status:"Completed" },
  { id:"#32000200", customer:"Mitchell Lane",     qty:3, date:"Aug 29, 2020", rev:"$675.51", profit:"$84.80",  status:"Completed" },
  { id:"#32000200", customer:"Arlene Richards",   qty:4, date:"Dec 26, 2020", rev:"$910.71", profit:"$46.52",  status:"Shipping"  },
  { id:"#32000200", customer:"Angel Howard",      qty:2, date:"Apr 27, 2020", rev:"$897.90", profit:"$81.54",  status:"Completed" },
  { id:"#32000200", customer:"Greg Fox",          qty:1, date:"May 5, 2020",  rev:"$563.43", profit:"$17.46",  status:"Pending"   },
  { id:"#32000200", customer:"Devon Bell",        qty:4, date:"Oct 15, 2020", rev:"$883.96", profit:"$43.08",  status:"Refund"    },
  { id:"#32000200", customer:"Shane Henry",       qty:3, date:"Jul 12, 2020", rev:"$162.15", profit:"$86.65",  status:"Completed" },
  { id:"#32000200", customer:"Stella Webb",       qty:2, date:"Jun 28, 2020", rev:"$378.34", profit:"$49.08",  status:"Completed" },
];
const CUSTOMER_ORDERS = [
  { customer:"Sarah Mitchell",  initials:"SM", color:"#E6F1FB", tcolor:"#0C447C", id:"#5302002", product:"Basket with handles",  cat:"Grocery",    qty:2, date:"Jan 10, 2020", rev:"$253.82", profit:"$60.76",  status:"Completed" },
  { customer:"James Okafor",    initials:"JO", color:"#E1F5EE", tcolor:"#085041", id:"#5302003", product:"Wireless Headphones",  cat:"Electronics", qty:1, date:"Sep 4, 2020",  rev:"$556.24", profit:"$66.41",  status:"Completed" },
  { customer:"Priya Sharma",    initials:"PS", color:"#FBEAF0", tcolor:"#72243E", id:"#5302004", product:"Yoga Mat Pro",         cat:"Fitness",     qty:3, date:"Aug 30, 2020", rev:"$115.26", profit:"$95.66",  status:"Completed" },
  { customer:"Carlos Ruiz",     initials:"CR", color:"#FAEEDA", tcolor:"#854F0B", id:"#5302005", product:"Coffee Maker Deluxe",  cat:"Kitchen",     qty:1, date:"Aug 29, 2020", rev:"$675.51", profit:"$84.80",  status:"Completed" },
  { customer:"Emily Chen",      initials:"EC", color:"#EEEDFE", tcolor:"#3C3489", id:"#5302006", product:"Running Sneakers",    cat:"Footwear",    qty:4, date:"Dec 26, 2020", rev:"$910.71", profit:"$46.52",  status:"Completed" },
  { customer:"Sarah Mitchell",  initials:"SM", color:"#E6F1FB", tcolor:"#0C447C", id:"#5302007", product:"Organic Tea Set",     cat:"Grocery",     qty:2, date:"Apr 27, 2020", rev:"$897.90", profit:"$81.54",  status:"Completed" },
  { customer:"James Okafor",    initials:"JO", color:"#E1F5EE", tcolor:"#085041", id:"#5302008", product:"Desk Lamp LED",       cat:"Electronics", qty:1, date:"May 5, 2020",  rev:"$563.43", profit:"$17.46",  status:"Pending"   },
  { customer:"Lena Müller",     initials:"LM", color:"#FAECE7", tcolor:"#712B13", id:"#5302009", product:"Winter Jacket",       cat:"Apparel",     qty:2, date:"Oct 15, 2020", rev:"$883.96", profit:"$43.08",  status:"Refund"    },
  { customer:"Priya Sharma",    initials:"PS", color:"#FBEAF0", tcolor:"#72243E", id:"#5302010", product:"Blender Pro 600W",    cat:"Kitchen",     qty:1, date:"Jul 12, 2020", rev:"$162.15", profit:"$86.65",  status:"Pending"   },
  { customer:"Carlos Ruiz",     initials:"CR", color:"#FAEEDA", tcolor:"#854F0B", id:"#5302012", product:"Basket with handles", cat:"Grocery",     qty:2, date:"Jun 28, 2020", rev:"$378.34", profit:"$49.08",  status:"Completed" },
];

//const statusColor = (s) => s === "Completed" ? "#3B6D11" : s === "Pending" ? "#854F0B" : "#A32D2D";
const statusBg    = (s) => s === "Completed" ? "#EAF3DE" : s === "Pending" ? "#FAEEDA" : "#FCEBEB";



// ─── Mock Product Config ──────────────────────────────────────────────────────
const MOCK_PRODUCT_CONFIG = {
  category: { name: "Soccer Kits" },
  neckStyle: "Crew Neck",
  sleeveType: "Half Sleeves",
  design: { name: "Diagonal A" },
  colors: {
    shirtFront: "#ffd200", shirtBack: "#ffd200",
    leftArmStripe: "#2a2828", rightArmStripe: "#2a2828",
    leftSleeve: "#2a2828", rightSleeve: "#2a2828",
    neckCollar: "#cfab0f", pants: "#2a2828",
  },
  pattern: {
    frontEnabled: true, frontPatternName: "Zig Zag", frontPatternColor: "#1e4ed8",
    backEnabled: false, backPatternName: "None", backPatternColor: "#000000",
  },
  gradient: {
    enabled: false, angle: 90,
    stops: [{ color:"#1e293b",pos:0},{ color:"#0ea5e9",pos:0.5},{ color:"#22c55e",pos:1}],
  },
  numbers: {
    front: { enabled:true,  value:"10", color:"#ffffff", strokeColor:"#000000" },
    back:  { enabled:true,  value:"10", color:"#ffffff", strokeColor:"#000000" },
    shortsFront: { enabled:false, value:"", color:"#ffffff", strokeColor:"#000000" },
    shortsBack:  { enabled:false, value:"", color:"#ffffff", strokeColor:"#000000" },
  },
  backName:  { enabled:true,  text:"MESSI", color:"#ffffff", strokeColor:"#000000" },
  frontText: { enabled:false, text:"",      color:"#ffffff", strokeColor:"#000000" },
  logos: [
    { part:"Shirt Front",  name:"Swoosh",  count:1 },
    { part:"Shorts Front", name:"Brand X", count:1 },
  ],
};

function formatConfigForTab(tabKey) {
  switch (tabKey) {
    case "Categories": return `Kit: ${MOCK_PRODUCT_CONFIG.category.name}`;
    case "Styling":    return `${MOCK_PRODUCT_CONFIG.neckStyle}, ${MOCK_PRODUCT_CONFIG.sleeveType}`;
    case "Design":     return `Design: ${MOCK_PRODUCT_CONFIG.design.name}`;
    case "Color": {
      const c = MOCK_PRODUCT_CONFIG.colors;
      return `Shirt Front: ${c.shirtFront} | Back: ${c.shirtBack}\nLeft Arm Stripe: ${c.leftArmStripe} | Right Arm Stripe: ${c.rightArmStripe}\nLeft Sleeve: ${c.leftSleeve} | Right Sleeve: ${c.rightSleeve}\nNeck / Collar: ${c.neckCollar}\nPants: ${c.pants}`;
    }
    case "Pattern": {
      const p = MOCK_PRODUCT_CONFIG.pattern;
      return `Show Front Pattern: ${p.frontEnabled?"Yes":"No"}${p.frontEnabled?` (${p.frontPatternName})`:""}\nPattern Color: ${p.frontEnabled?p.frontPatternColor:"—"}\nShow Back Pattern: ${p.backEnabled?"Yes":"No"}${p.backEnabled?` (${p.backPatternName})`:""}`;
    }
    case "Gradient": {
      const g = MOCK_PRODUCT_CONFIG.gradient;
      if (!g.enabled) return "Apply gradient: No";
      return `Apply gradient: Yes\nAngle: ${g.angle} deg\nStops: ${g.stops.map(s=>`${s.color} @ ${Math.round(s.pos*100)}%`).join(" | ")}`;
    }
    case "Number": {
      const n = MOCK_PRODUCT_CONFIG.numbers;
      return `Front: ${n.front.enabled?`Yes (${n.front.value})`:"No"} — Color: ${n.front.color}\nBack: ${n.back.enabled?`Yes (${n.back.value})`:"No"} — Color: ${n.back.color}\nShorts Front: ${n.shortsFront.enabled?`Yes (${n.shortsFront.value})`:"No"}\nShorts Back: ${n.shortsBack.enabled?`Yes (${n.shortsBack.value})`:"No"}`;
    }
    case "Name": {
      const bn = MOCK_PRODUCT_CONFIG.backName;
      return `Back Name: ${bn.enabled?`"${bn.text}" (Color: ${bn.color})`:"Not set"}`;
    }
    case "Text": {
      const ft = MOCK_PRODUCT_CONFIG.frontText;
      return `Front Text: ${ft.enabled?`"${ft.text}" (Color: ${ft.color})`:"Not set"}`;
    }
    case "Logo": {
      const logos = MOCK_PRODUCT_CONFIG.logos;
      return logos.length === 0 ? "No logos added" : logos.map(l=>`${l.part}: ${l.name}`).join("\n");
    }
    default: return "—";
  }
}

// ─── Helpers ─────────────────────────────────────────────────────────────────
function statusColor(s) {
  if (s === "Completed") return T.accent;
  if (s === "Shipping")  return T.text;
  if (s === "Pending")   return T.orange;
  if (s === "Refund")    return T.red;
  return T.muted;
}

function Avatar({ name, size = 32 }) {
  const initials = name.split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase();
  const colors = ["#22c55e","#60a5fa","#f97316","#a78bfa","#f472b6","#34d399"];
  const idx = name.charCodeAt(0) % colors.length;
  return (
    <div style={{
      width:size, height:size, borderRadius:"50%",
      background:colors[idx]+"33", border:`1.5px solid ${colors[idx]}55`,
      display:"flex", alignItems:"center", justifyContent:"center",
      fontSize:size*0.35, fontWeight:600, color:colors[idx], flexShrink:0,
    }}>{initials}</div>
  );
}

function StatCard({ label, value, pct, up }) {
  return (
    <div style={{
      background:T.card, border:`1px solid ${T.border}`, borderRadius:14,
      padding:"18px 22px", flex:1, minWidth:160,
    }}>
      <p style={{ margin:0, fontSize:12, color:T.muted, marginBottom:6 }}>{label}</p>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <span style={{ fontSize:24, fontWeight:700, color:T.text }}>{value}</span>
        <span style={{ fontSize:12, fontWeight:600, color:up?T.accent:T.red }}>{pct}</span>
      </div>
    </div>
  );
}

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={{
      background:T.cardAlt, border:`1px solid ${T.accentBorder}`,
      borderRadius:8, padding:"8px 14px", fontSize:12, color:T.text,
    }}>
      <p style={{ margin:0, color:T.muted }}>{label}</p>
      <p style={{ margin:"4px 0 0", color:T.accent, fontWeight:600 }}>{payload[0]?.value?.toLocaleString()}</p>
    </div>
  );
};

function ActionBtns() {
  return (
    <div style={{ display:"flex", gap:6 }}>
      {["👁","✏️","🗑"].map((ic,i) => (
        <button key={i} style={{
          background:"transparent", border:`1px solid ${T.border}`,
          borderRadius:6, padding:"4px 7px", cursor:"pointer", fontSize:12, color:T.muted,
        }}>{ic}</button>
      ))}
    </div>
  );
}

function RevenueChart() {
  const data = [
    {m:"Jan",rev:7825,profit:3200},{m:"Feb",rev:9200,profit:4100},
    {m:"Mar",rev:8400,profit:3500},{m:"Apr",rev:11000,profit:5200},
    {m:"May",rev:9800,profit:4800},{m:"Jun",rev:12500,profit:6100},
  ];
  return (
    <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
      <div style={{ display:"flex", justifyContent:"space-between", marginBottom:16 }}>
        <span style={{ fontSize:14, fontWeight:600, color:T.text }}>Revenue</span>
        <div style={{ display:"flex", gap:16, fontSize:12 }}>
          <span style={{ display:"flex", alignItems:"center", gap:5 }}>
            <span style={{ width:8,height:8,borderRadius:"50%",background:T.accent,display:"inline-block"}}/>
            <span style={{ color:T.muted }}>Revenue</span>
          </span>
          <span style={{ display:"flex", alignItems:"center", gap:5 }}>
            <span style={{ width:8,height:8,borderRadius:"50%",background:T.blue,display:"inline-block"}}/>
            <span style={{ color:T.muted }}>Net Profit</span>
          </span>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={data}>
          <CartesianGrid stroke={T.border} strokeDasharray="3 3"/>
          <XAxis dataKey="m" tick={{fill:T.faint,fontSize:11}} axisLine={false} tickLine={false}/>
          <YAxis tick={{fill:T.faint,fontSize:11}} axisLine={false} tickLine={false}
            tickFormatter={v=>`$${(v/1000).toFixed(0)}k`}/>
          <Tooltip content={<CustomTooltip/>}/>
          <Line type="monotone" dataKey="rev" stroke={T.accent} strokeWidth={2.5} dot={false}/>
          <Line type="monotone" dataKey="profit" stroke={T.blue} strokeWidth={2.5} dot={false}/>
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

function OrdersTable({ title, rows, type }) {
  return (
    <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
      <div style={{ display:"flex", justifyContent:"space-between", marginBottom:14 }}>
        <span style={{ fontSize:14, fontWeight:600, color:T.text }}>{title}</span>
        <span style={{ fontSize:12, color:T.accent, cursor:"pointer" }}>More →</span>
      </div>
      <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
        <thead>
          <tr>
            {(type === "full"
              ? ["Order ID","Items","Date","Customer","Revenue","Net Profit","Status","Actions"]
              : ["Product","Qty","Date","Revenue","Net Profit","Status"]
            ).map(h => (
              <th key={h} style={{
                textAlign:"left", color:T.faint, fontWeight:500,
                paddingBottom:12, borderBottom:`1px solid ${T.border}`,
              }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r,i) => (
            <tr key={i} style={{ borderBottom:`1px solid ${T.border}` }}>
              {type === "full" ? (
                <>
                  <td style={{ padding:"12px 0", color:T.muted, fontSize:12 }}>{r.id}</td>
                  <td style={{ color:T.muted }}>{r.items}</td>
                  <td style={{ color:T.muted }}>{r.date}</td>
                  <td>
                    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <Avatar name={r.customer} size={28}/>
                      <span style={{ color:T.text }}>{r.customer}</span>
                    </div>
                  </td>
                  <td style={{ color:T.text, fontWeight:500 }}>{r.rev}</td>
                  <td style={{ color:T.muted }}>{r.profit}</td>
                  <td><span style={{ color:statusColor(r.status), fontWeight:600 }}>{r.status}</span></td>
                  <td><ActionBtns/></td>
                </>
              ) : (
                <>
                  <td style={{ padding:"12px 0", color:T.text }}>{r.product}</td>
                  <td style={{ color:T.muted }}>{r.qty}</td>
                  <td style={{ color:T.muted }}>{r.date}</td>
                  <td style={{ color:T.text, fontWeight:500 }}>{r.rev}</td>
                  <td style={{ color:T.muted }}>{r.profit}</td>
                  <td><span style={{ color:statusColor(r.status), fontWeight:600 }}>{r.status}</span></td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// ─── Load jsPDF from CDN ──────────────────────────────────────────────────────
function loadJsPDF() {
  return new Promise((resolve, reject) => {
    if (window.jspdf) { resolve(window.jspdf); return; }
    const script = document.createElement("script");
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
    script.onload  = () => resolve(window.jspdf);
    script.onerror = () => reject(new Error("Failed to load jsPDF"));
    document.head.appendChild(script);
  });
}

// ─── Product Configuration Summary + PDF ─────────────────────────────────────
function ProductConfigurationSummary() {
  const [pdfLoading, setPdfLoading] = useState(false);

  const TABS = ["Categories","Styling","Design","Color","Pattern","Gradient","Number","Name","Text","Logo"];

  const handleEdit = (tabName) => {
    alert(`Edit "${tabName}" – would open the configurator with current settings.`);
  };

  // ── Generate PDF (all real selectable text via jsPDF) ──────────────────────
/*
  const generatePDF = async () => {
    setPdfLoading(true);
    try {
      const { jsPDF } = await loadJsPDF();
      const doc = new jsPDF({ unit:"pt", format:"a4" });

      const pageW  = doc.internal.pageSize.getWidth();
      const pageH  = doc.internal.pageSize.getHeight();
      const margin = 48;
      const colW   = pageW - margin * 2;
      let   y      = margin;

      // ── Helper: check page break ──
      const checkPage = (needed = 20) => {
        if (y + needed > pageH - margin) {
          doc.addPage();
          y = margin;
        }
      };

      // ── Header banner ──
      doc.setFillColor(15, 23, 42);           // sidebar dark
      doc.rect(0, 0, pageW, 72, "F");
      doc.setFillColor(34, 197, 94);          // accent green
      doc.rect(0, 68, pageW, 4, "F");

      doc.setFont("helvetica", "bold");
      doc.setFontSize(22);
      doc.setTextColor(229, 231, 235);
      doc.text("Product Configuration Report", margin, 44);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(156, 163, 175);
      const now = new Date().toLocaleString();
      doc.text(`Generated: ${now}`, margin, 60);

      y = 104;

      // ── Kit info block ──
      doc.setFillColor(0, 0, 0); // Black background
        doc.roundedRect(margin, y, colW, 54, 6, 6, "F");

        doc.setFont("helvetica", "bold");
        doc.setFontSize(13);
        doc.setTextColor(255, 255, 255); // White text
        doc.text("Soccer Kits  —  Diagonal A Design", margin + 16, y + 20);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255); // White text for the second line too
        doc.text(`Neck Style: ${MOCK_PRODUCT_CONFIG.neckStyle}   |   Sleeve: ${MOCK_PRODUCT_CONFIG.sleeveType}`, margin + 16, y + 38);

        y += 70;
      // ── Section title helper ──
      const sectionTitle = (title) => {
        checkPage(32);
        doc.setFillColor(34, 197, 94, 0.15);
        doc.setDrawColor(34, 197, 94);
        doc.setLineWidth(0.5);
        doc.roundedRect(margin, y, colW, 26, 4, 4, "FD");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        doc.setTextColor(34, 197, 94);
        doc.text(title, margin + 12, y + 17);
        y += 34;
      };

      // ── Row helper ──
      const rowHeight = 22;
      let rowAlt = false;
      const drawRow = (label, value) => {
        const lines  = doc.splitTextToSize(value, colW - 120);
        const needed = Math.max(rowHeight, lines.length * 14 + 10);
        checkPage(needed);

        if (rowAlt) {
          doc.setFillColor(17, 24, 39);
          doc.rect(margin, y, colW, needed, "F");
        }
        rowAlt = !rowAlt;

        // Label
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.setTextColor(229, 231, 235);
        doc.text(label, margin + 10, y + 15);

        // Value
        doc.setFont("helvetica", "normal");
        doc.setTextColor(156, 163, 175);
        doc.text(lines, margin + 120, y + 15);

        y += needed;
      };

      // ── Colors section ──
      sectionTitle("Colors");
      rowAlt = false;
      const c = MOCK_PRODUCT_CONFIG.colors;
      drawRow("Shirt Front",      c.shirtFront);
      drawRow("Shirt Back",       c.shirtBack);
      drawRow("Left Arm Stripe",  c.leftArmStripe);
      drawRow("Right Arm Stripe", c.rightArmStripe);
      drawRow("Left Sleeve",      c.leftSleeve);
      drawRow("Right Sleeve",     c.rightSleeve);
      drawRow("Neck / Collar",    c.neckCollar);
      drawRow("Pants",            c.pants);

      // ── Pattern section ──
      y += 12;
      sectionTitle("Pattern");
      rowAlt = false;
      const p = MOCK_PRODUCT_CONFIG.pattern;
      drawRow("Front Pattern", p.frontEnabled ? `Yes — ${p.frontPatternName}` : "No");
      drawRow("Front Color",   p.frontEnabled ? p.frontPatternColor : "—");
      drawRow("Back Pattern",  p.backEnabled  ? `Yes — ${p.backPatternName}`  : "No");

      // ── Gradient section ──
      y += 12;
      sectionTitle("Gradient");
      rowAlt = false;
      const g = MOCK_PRODUCT_CONFIG.gradient;
      drawRow("Apply Gradient", g.enabled ? "Yes" : "No");
      if (g.enabled) {
        drawRow("Angle", `${g.angle} degrees`);
        drawRow("Color Stops", g.stops.map(s=>`${s.color} @ ${Math.round(s.pos*100)}%`).join("  |  "));
      }

      // ── Numbers section ──
      y += 12;
      sectionTitle("Numbers");
      rowAlt = false;
      const n = MOCK_PRODUCT_CONFIG.numbers;
      drawRow("Front Number",       n.front.enabled       ? `Yes — "${n.front.value}"  Color: ${n.front.color}`             : "No");
      drawRow("Back Number",        n.back.enabled        ? `Yes — "${n.back.value}"  Color: ${n.back.color}`               : "No");
      drawRow("Shorts Front Number",n.shortsFront.enabled ? `Yes — "${n.shortsFront.value}"  Color: ${n.shortsFront.color}` : "No");
      drawRow("Shorts Back Number", n.shortsBack.enabled  ? `Yes — "${n.shortsBack.value}"  Color: ${n.shortsBack.color}`   : "No");

      // ── Name & Text section ──
      y += 12;
      sectionTitle("Name & Text");
      rowAlt = false;
      const bn = MOCK_PRODUCT_CONFIG.backName;
      const ft = MOCK_PRODUCT_CONFIG.frontText;
      drawRow("Back Name",   bn.enabled ? `"${bn.text}"  Color: ${bn.color}  Stroke: ${bn.strokeColor}` : "Not set");
      drawRow("Front Text",  ft.enabled ? `"${ft.text}"  Color: ${ft.color}  Stroke: ${ft.strokeColor}` : "Not set");

      // ── Logos section ──
      y += 12;
      sectionTitle("Logos");
      rowAlt = false;
      if (MOCK_PRODUCT_CONFIG.logos.length === 0) {
        drawRow("Logos", "None added");
      } else {
        MOCK_PRODUCT_CONFIG.logos.forEach(l => drawRow(l.part, l.name));
      }

      // ── Footer on every page ──
      const totalPages = doc.internal.getNumberOfPages();
      for (let pg = 1; pg <= totalPages; pg++) {
        doc.setPage(pg);
        doc.setFillColor(15, 23, 42);
        doc.rect(0, pageH - 36, pageW, 36, "F");
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.setTextColor(107, 114, 128);
        doc.text("Soccer Kits — Configuration Report", margin, pageH - 14);
        doc.text(`Page ${pg} of ${totalPages}`, pageW - margin - 60, pageH - 14);
      }

      doc.save("product-configuration.pdf");
    } catch (err) {
      console.error("PDF generation failed:", err);
      alert("PDF generation failed. Please try again.");
    } finally {
      setPdfLoading(false);
    }
  };*/
const generatePDF = async () => {
  setPdfLoading(true);
  try {
    const { jsPDF } = await loadJsPDF();
    const doc = new jsPDF({ unit: "pt", format: "a4" });

    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const margin = 48;
    const colW = pageW - margin * 2;
    let y = margin;

    // ── Fill entire page with #0F152A ──
    const fillBgColor = () => {
      doc.setFillColor(15, 21, 42); // #0F152A
      doc.rect(0, 0, pageW, pageH, "F");
    };

    // ── Helper: check page break, add new page and fill it ──
    const checkPage = (needed = 20) => {
      if (y + needed > pageH - margin) {
        doc.addPage();
        fillBgColor();
        y = margin;
      }
    };

    // Fill first page
    fillBgColor();

    // ── Header (white text, subtle accent) ──
    doc.setFont("helvetica", "bold");
    doc.setFontSize(22);
    doc.setTextColor(255, 255, 255);
    doc.text("Product Configuration Report", margin, 44);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(200, 200, 200);
    const now = new Date().toLocaleString();
    doc.text(`Generated: ${now}`, margin, 60);

    // Accent line (light gray/white)
    doc.setDrawColor(255, 255, 255);
    doc.setLineWidth(0.5);
    doc.line(margin, 68, pageW - margin, 68);

    y = 104;
    // ── ADD IMAGE HERE ──
    // Replace with your actual image (base64 or URL)
    // Example using a base64 placeholder; you can also use a URL if allowed.
    const imgData = placeholderImg; // YOUR BASE64 OR URL
    // Optional: calculate image dimensions to fit within column width
    const imgWidth = 180; // desired width in points
    const imgHeight = 250; // desired height
    // Add image centered or left-aligned 
    doc.addImage(imgData, "PNG", margin, y, imgWidth, imgHeight);
    y += imgHeight + 16; // move y after image + spacing

    // ── Kit info block (slightly lighter background for contrast) ──
    doc.setFillColor(25, 32, 55); // slightly lighter than #0F152A
    doc.roundedRect(margin, y, colW, 54, 6, 6, "F");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.setTextColor(255, 255, 255);
    doc.text("Soccer Kits  —  Diagonal A Design", margin + 16, y + 20);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(200, 200, 200);
    doc.text(
      `Neck Style: ${MOCK_PRODUCT_CONFIG.neckStyle}   |   Sleeve: ${MOCK_PRODUCT_CONFIG.sleeveType}`,
      margin + 16,
      y + 38
    );

    y += 70;

    // ── Section title helper (dark background, white border) ──
     const sectionTitle = (title) => {
      checkPage(32);
      doc.setFillColor(10, 14, 28);
      doc.setDrawColor(255, 255, 255);
      doc.setLineWidth(0.5);
      doc.roundedRect(margin, y, colW, 26, 4, 4, "FD");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.setTextColor(255, 255, 255);
      doc.text(title, margin + 12, y + 17);
      y += 34;
    };

    const rowHeight = 22;
    let rowAlt = false;
    const drawRow = (label, value) => {
      const lines = doc.splitTextToSize(value, colW - 120);
      const needed = Math.max(rowHeight, lines.length * 14 + 10);
      checkPage(needed);
      if (rowAlt) {
        doc.setFillColor(20, 26, 48);
        doc.rect(margin, y, colW, needed, "F");
      }
      rowAlt = !rowAlt;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor(255, 255, 255);
      doc.text(label, margin + 10, y + 15);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(200, 200, 200);
      doc.text(lines, margin + 120, y + 15);
      y += needed;
    };

    // ── Colors section ──
    sectionTitle("Colors");
    rowAlt = false;
    const c = MOCK_PRODUCT_CONFIG.colors;
    drawRow("Shirt Front", c.shirtFront);
    drawRow("Shirt Back", c.shirtBack);
    drawRow("Left Arm Stripe", c.leftArmStripe);
    drawRow("Right Arm Stripe", c.rightArmStripe);
    drawRow("Left Sleeve", c.leftSleeve);
    drawRow("Right Sleeve", c.rightSleeve);
    drawRow("Neck / Collar", c.neckCollar);
    drawRow("Pants", c.pants);

    // ── Pattern section ──
    y += 12;
    sectionTitle("Pattern");
    rowAlt = false;
    const p = MOCK_PRODUCT_CONFIG.pattern;
    drawRow("Front Pattern", p.frontEnabled ? `Yes — ${p.frontPatternName}` : "No");
    drawRow("Front Color", p.frontEnabled ? p.frontPatternColor : "—");
    drawRow("Back Pattern", p.backEnabled ? `Yes — ${p.backPatternName}` : "No");

    // ── Gradient section ──
    y += 12;
    sectionTitle("Gradient");
    rowAlt = false;
    const g = MOCK_PRODUCT_CONFIG.gradient;
    drawRow("Apply Gradient", g.enabled ? "Yes" : "No");
    if (g.enabled) {
      drawRow("Angle", `${g.angle} degrees`);
      drawRow(
        "Color Stops",
        g.stops.map((s) => `${s.color} @ ${Math.round(s.pos * 100)}%`).join("  |  ")
      );
    }

    // ── Numbers section ──
    y += 12;
    sectionTitle("Numbers");
    rowAlt = false;
    const n = MOCK_PRODUCT_CONFIG.numbers;
    drawRow(
      "Front Number",
      n.front.enabled ? `Yes — "${n.front.value}"  Color: ${n.front.color}` : "No"
    );
    drawRow(
      "Back Number",
      n.back.enabled ? `Yes — "${n.back.value}"  Color: ${n.back.color}` : "No"
    );
    drawRow(
      "Shorts Front Number",
      n.shortsFront.enabled
        ? `Yes — "${n.shortsFront.value}"  Color: ${n.shortsFront.color}`
        : "No"
    );
    drawRow(
      "Shorts Back Number",
      n.shortsBack.enabled
        ? `Yes — "${n.shortsBack.value}"  Color: ${n.shortsBack.color}`
        : "No"
    );

    // ── Name & Text section ──
    y += 12;
    sectionTitle("Name & Text");
    rowAlt = false;
    const bn = MOCK_PRODUCT_CONFIG.backName;
    const ft = MOCK_PRODUCT_CONFIG.frontText;
    drawRow(
      "Back Name",
      bn.enabled
        ? `"${bn.text}"  Color: ${bn.color}  Stroke: ${bn.strokeColor}`
        : "Not set"
    );
    drawRow(
      "Front Text",
      ft.enabled
        ? `"${ft.text}"  Color: ${ft.color}  Stroke: ${ft.strokeColor}`
        : "Not set"
    );

    // ── Logos section ──
    y += 12;
    sectionTitle("Logos");
    rowAlt = false;
    if (MOCK_PRODUCT_CONFIG.logos.length === 0) {
      drawRow("Logos", "None added");
    } else {
      MOCK_PRODUCT_CONFIG.logos.forEach((l) => drawRow(l.part, l.name));
    }

    // ── Footer on every page (same background color) ──
    const totalPages = doc.internal.getNumberOfPages();
    for (let pg = 1; pg <= totalPages; pg++) {
      doc.setPage(pg);
      // Footer background (match main background)
      doc.setFillColor(15, 21, 42);
      doc.rect(0, pageH - 36, pageW, 36, "F");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(150, 150, 150);
      doc.text("Soccer Kits — Configuration Report", margin, pageH - 14);
      doc.text(`Page ${pg} of ${totalPages}`, pageW - margin - 60, pageH - 14);
    }

    doc.save("product-configuration.pdf");
  } catch (err) {
    console.error("PDF generation failed:", err);
    alert("PDF generation failed. Please try again.");
  } finally {
    setPdfLoading(false);
  }
};
  // ── Placeholder image ──
 

  return (
    <div style={{ marginBottom: 20 }}>
      {/* Two-column layout */}
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:14 }}>
        {/* Left – Product Image */}
        <div style={{
          background:T.card, border:`1px solid ${T.border}`, borderRadius:14,
          padding:20, display:"flex", alignItems:"center", justifyContent:"center", minHeight:300,
        }}>
          <img
            src={placeholderImg}
            alt="Product preview"
            style={{ maxWidth:"100%", objectFit:"contain", borderRadius:8 }}
          />
        </div>

        {/* Right – Configuration Table */}
        <div style={{
          background:T.card, border:`1px solid ${T.border}`, borderRadius:14,
          padding:20, overflowX:"auto",
        }}>
          <h3 style={{ margin:"0 0 16px", fontSize:16, color:T.text }}>Current Configuration</h3>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
            <tbody>
              {TABS.map(tab => (
                <tr key={tab} style={{ borderBottom:`1px solid ${T.border}` }}>
                  <td style={{ padding:"12px 8px 12px 0", fontWeight:600, color:T.text, verticalAlign:"top", width:100 }}>
                    {tab}
                  </td>
                  <td style={{ padding:"12px 8px", color:T.muted, whiteSpace:"pre-line", verticalAlign:"top" }}>
                    {formatConfigForTab(tab).split("\n").map((line,i) => (
                      <div key={i}>{line || <br/>}</div>
                    ))}
                  </td>
                  <td style={{ padding:"12px 0 12px 8px", textAlign:"right", verticalAlign:"middle" }}>
                    <button
                      onClick={() => handleEdit(tab)}
                      style={{
                        background:T.accentDim, border:`1px solid ${T.accentBorder}`,
                        color:T.accent, borderRadius:6, padding:"4px 12px",
                        cursor:"pointer", fontSize:12, fontWeight:600,
                      }}
                    >Edit</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── PDF Download Button ── */}
      <div style={{
        display:"flex", justifyContent:"flex-end", alignItems:"center",
        gap:12, padding:"14px 0",
      }}>
        <span style={{ fontSize:12, color:T.muted }}>
          Export this configuration as a text-based PDF
        </span>
        <button
          onClick={generatePDF}
          disabled={pdfLoading}
          style={{
            display:"flex", alignItems:"center", gap:8,
            background: pdfLoading ? T.cardAlt : "linear-gradient(135deg, #0D66D3, rgba(27, 115, 223, 0.66))",
            border: pdfLoading ? `1px solid ${T.border}` : "none",
            color: pdfLoading ? T.muted : "#fff",
            borderRadius:10, padding:"10px 22px",
            cursor: pdfLoading ? "not-allowed" : "pointer",
            fontSize:13, fontWeight:700,
            boxShadow: pdfLoading ? "none" : "0 4px 14px rgba(13, 102, 211, 0.8)",
            transition:"all 0.2s",
          }}
        >
          {pdfLoading ? (
            <>
              <span style={{
                width:14, height:14, border:`2px solid ${T.muted}`,
                borderTopColor:"transparent", borderRadius:"50%",
                display:"inline-block",
                animation:"spin 0.7s linear infinite",
              }}/>
              Generating…
            </>
          ) : (
            <>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
              Download Configuration PDF
            </>
          )}
        </button>
      </div>

      {/* spinner keyframe */}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

// ─── NAV ─────────────────────────────────────────────────────────────────────
const NAV = [
  { key:"dashboard",  label:"Dashboard",  icon:"⊞" },
  { key:"orders",     label:"Orders",     icon:"≡" },
  { key:"products",   label:"Products",   icon:"🛍" },
  { key:"customers",  label:"Customers",  icon:"👤" },
  //{ key:"analytics",  label:"Analytics",  icon:"📈" },
];

// ─── PAGE: DASHBOARD ─────────────────────────────────────────────────────────
function DashboardPage() {
  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
        <h1 style={{ margin:0, fontSize:22, fontWeight:700, color:T.text }}>Dashboard</h1>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:10, padding:"8px 16px", fontSize:13, color:T.muted }}>
          Jan 01 – Jan 28 ▾
        </div>
      </div>
      <div style={{ display:"flex", gap:14, marginBottom:20, flexWrap:"wrap" }}>
        {DASHBOARD_STATS.map(s => <StatCard key={s.label} {...s}/>)}
      </div>
      {/*<div style={{ display:"grid", gridTemplateColumns:"1fr 280px", gap:14, marginBottom:20 }}>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
            <span style={{ fontSize:14, fontWeight:600, color:T.text }}>Sales Overview</span>
            <span style={{ fontSize:12, color:T.accent, cursor:"pointer" }}>Advanced Report →</span>
          </div>
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={BAR_DATA} barSize={14}>
              <XAxis dataKey="d" tick={{fill:T.faint,fontSize:11}} axisLine={false} tickLine={false}/>
              <YAxis tick={{fill:T.faint,fontSize:11}} axisLine={false} tickLine={false}
                tickFormatter={v=>v>=1000?`$${v/1000}k`:`$${v}`}/>
              <Tooltip content={<CustomTooltip/>}/>
              <Bar dataKey="v" radius={[4,4,0,0]}>
                {BAR_DATA.map((entry,i) => (
                  <Cell key={i} fill={entry.hot?T.red:T.orange} opacity={entry.hot?1:0.75}/>
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
          <p style={{ margin:"0 0 16px", fontSize:14, fontWeight:600, color:T.text }}>Cart</p>
          <div style={{ display:"flex", justifyContent:"center", marginBottom:20 }}>
            <div style={{ position:"relative", width:120, height:120 }}>
              <svg width="120" height="120" viewBox="0 0 120 120">
                <circle cx="60" cy="60" r="50" fill="none" stroke={T.border} strokeWidth="10"/>
                <circle cx="60" cy="60" r="50" fill="none" stroke={T.accent} strokeWidth="10"
                  strokeDasharray={`${0.38*314} ${314}`} strokeLinecap="round"
                  transform="rotate(-90 60 60)"/>
              </svg>
              <div style={{ position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)", fontSize:20, fontWeight:700, color:T.text }}>38%</div>
            </div>
          </div>
          <div style={{ borderTop:`1px solid ${T.border}`, paddingTop:12 }}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:8 }}>
              <span style={{ fontSize:12, color:T.muted }}>Abandoned Cart</span>
              <span style={{ fontSize:12, fontWeight:600, color:T.text }}>720</span>
            </div>
            <div style={{ display:"flex", justifyContent:"space-between" }}>
              <span style={{ fontSize:12, color:T.muted }}>Abandoned Revenue</span>
              <span style={{ fontSize:12, fontWeight:600, color:T.text }}>$5,900</span>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:20 }}>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:16 }}>
            <span style={{ fontSize:14, fontWeight:600, color:T.text }}>Revenue by device</span>
            <span style={{ fontSize:12, color:T.accent, cursor:"pointer" }}>More →</span>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:20 }}>
            <ResponsiveContainer width={140} height={140}>
              <PieChart>
                <Pie data={DEVICE_DATA} cx="50%" cy="50%" innerRadius={42} outerRadius={65}
                  dataKey="value" startAngle={90} endAngle={-270}>
                  {DEVICE_DATA.map((d,i) => <Cell key={i} fill={d.color}/>)}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div style={{ flex:1 }}>
              {DEVICE_DATA.map(d => (
                <div key={d.name} style={{ display:"flex", justifyContent:"space-between", marginBottom:8, fontSize:12 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                    <span style={{ width:8, height:8, borderRadius:"50%", background:d.color, display:"inline-block"}}/>
                    <span style={{ color:T.muted }}>{d.name}</span>
                  </div>
                  <div style={{ display:"flex", gap:12 }}>
                    <span style={{ color:T.text, fontWeight:500 }}>{d.amt}</span>
                    <span style={{ color:T.faint }}>{d.value}%</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:12 }}>
            <span style={{ fontSize:14, fontWeight:600, color:T.text }}>Traffic</span>
            <span style={{ fontSize:12, color:T.accent, cursor:"pointer" }}>More →</span>
          </div>
          <div style={{ display:"flex", gap:16, marginBottom:14 }}>
            <div style={{ background:T.cardAlt, borderRadius:10, padding:"10px 16px", flex:1 }}>
              <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:T.muted, marginBottom:4 }}>
                <span>Store Visits</span><span style={{ color:T.accent }}>+22%</span>
              </div>
              <p style={{ margin:0, fontSize:20, fontWeight:700, color:T.text }}>8,950</p>
            </div>
            <div style={{ background:T.cardAlt, borderRadius:10, padding:"10px 16px", flex:1 }}>
              <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:T.muted, marginBottom:4 }}>
                <span>Visitors</span><span style={{ color:T.red }}>–24%</span>
              </div>
              <p style={{ margin:0, fontSize:20, fontWeight:700, color:T.text }}>1,520</p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={80}>
            <AreaChart data={LINE_DATA.slice(0,8)}>
              <defs>
                <linearGradient id="tg" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%"  stopColor={T.orange} stopOpacity={0.3}/>
                  <stop offset="95%" stopColor={T.orange} stopOpacity={0}/>
                </linearGradient>
              </defs>
              <Area type="monotone" dataKey="v" stroke={T.orange} strokeWidth={2} fill="url(#tg)" dot={false}/>
              <XAxis dataKey="d" tick={{fill:T.faint,fontSize:10}} axisLine={false} tickLine={false}/>
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:20 }}>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:14 }}>
            <span style={{ fontSize:14, fontWeight:600, color:T.text }}>Bestsellers</span>
            <span style={{ fontSize:12, color:T.accent, cursor:"pointer" }}>More →</span>
          </div>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
            <thead>
              <tr>{["Product","Price","Sold","Profit"].map(h=>(
                <th key={h} style={{ textAlign:"left", color:T.faint, fontWeight:500, paddingBottom:10 }}>{h}</th>
              ))}</tr>
            </thead>
            <tbody>
              {BESTSELLERS.map((r,i)=>(
                <tr key={i} style={{ borderTop:`1px solid ${T.border}` }}>
                  <td style={{ padding:"10px 0", color:T.text }}>{r.name}</td>
                  <td style={{ color:T.muted }}>{r.price}</td>
                  <td style={{ color:T.muted }}>{r.sold}</td>
                  <td style={{ color:T.accent, fontWeight:600 }}>{r.profit}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:14 }}>
            <span style={{ fontSize:14, fontWeight:600, color:T.text }}>Sales forecast</span>
            <span style={{ fontSize:12, color:T.accent, cursor:"pointer" }}>More →</span>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
            {FORECAST.map(f=>(
              <div key={f.label} style={{ background:T.cardAlt, borderRadius:10, padding:"14px 16px", border:`1px solid ${T.border}` }}>
                <p style={{ margin:"0 0 6px", fontSize:11, color:T.muted }}>{f.label}</p>
                <p style={{ margin:0, fontSize:20, fontWeight:700, color:f.up?T.accent:T.red }}>{f.val}</p>
              </div>
            ))}
          </div>
        </div>
      </div>*/}
      <OrdersTable title="Latest Orders" rows={LATEST_ORDERS} type="simple"/>
    </div>
  );
}

// ─── PAGE: ORDERS ─────────────────────────────────────────────────────────────
function OrdersPage() {
  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
        <h1 style={{ margin:0, fontSize:22, fontWeight:700, color:T.text }}>Orders</h1>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:10, padding:"8px 16px", fontSize:13, color:T.muted }}>
          Jan 01 – Jan 28 ▾
        </div>
      </div>
      <div style={{ display:"flex", gap:14, marginBottom:20, flexWrap:"wrap" }}>
        {DASHBOARD_STATS.map(s => <StatCard key={s.label} {...s}/>)}
      </div>

      {/* Configuration summary with PDF button */}
      <ProductConfigurationSummary />

      {/* Orders chart */}
      {/*
      <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20, marginBottom:20 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <span style={{ width:8, height:8, borderRadius:"50%", background:T.orange, display:"inline-block"}}/>
            <span style={{ fontSize:14, fontWeight:600, color:T.text }}>Orders Update</span>
          </div>
          <span style={{ fontSize:12, color:T.accent, cursor:"pointer" }}>View Details →</span>
        </div>
        
        <ResponsiveContainer width="100%" height={240}>
          <AreaChart data={LINE_DATA}>
            <defs>
              <linearGradient id="og" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%"  stopColor={T.orange} stopOpacity={0.25}/>
                <stop offset="95%" stopColor={T.orange} stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid stroke={T.border} strokeDasharray="3 3"/>
            <XAxis dataKey="d" tick={{fill:T.faint,fontSize:11}} axisLine={false} tickLine={false}/>
            <YAxis tick={{fill:T.faint,fontSize:11}} axisLine={false} tickLine={false}
              tickFormatter={v=>`${(v/1000).toFixed(1)}M`}/>
            <Tooltip content={<CustomTooltip/>}/>
            <Area type="monotone" dataKey="v" stroke={T.orange} strokeWidth={2.5}
              fill="url(#og)" dot={false}
              activeDot={{ r:6, fill:T.orange, stroke:T.card, strokeWidth:2 }}/>
          </AreaChart>
        </ResponsiveContainer>
      </div>*/}
      <OrdersTable title="Latest Orders" rows={ORDERS_TABLE} type="full"/>
    </div>
  );
}

// ─── PAGE: PRODUCTS ───────────────────────────────────────────────────────────
function ProductsPage() {
  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
        <h1 style={{ margin:0, fontSize:22, fontWeight:700 }}>
          <span style={{ color:T.accent }}>Products</span>
          
        </h1>
      </div>
      <div style={{ display:"flex", gap:14, marginBottom:20, flexWrap:"wrap" }}>
        {PRODUCT_STATS.map(s => <StatCard key={s.label} {...s}/>)}
      </div>
      {/*
      <div style={{ display:"grid", gridTemplateColumns:"300px 1fr", gap:14, marginBottom:20 }}>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:24 }}>
          <div style={{ display:"flex", flexDirection:"column", alignItems:"center", marginBottom:20 }}>
            <div style={{ width:80, height:80, borderRadius:16, background:T.cardAlt, display:"flex", alignItems:"center", justifyContent:"center", fontSize:36, marginBottom:12, border:`1px solid ${T.border}` }}>🕐</div>
            <p style={{ margin:"0 0 4px", fontSize:15, fontWeight:700, color:T.text }}>Analog Table Clock</p>
            <p style={{ margin:0, fontSize:12, color:T.muted }}>General</p>
          </div>
          <div style={{ borderTop:`1px solid ${T.border}`, paddingTop:16 }}>
            {[
              { icon:"📁", label:"In Stock",        val:"9,520"                       },
              { icon:"🎨", label:"Colors",          val:"Black, White, Blue, Yellow"  },
              { icon:"📅", label:"Start Time",      val:"September 30, 2018"          },
              { icon:"📋", label:"Life Time Sells", val:"40,02,030"                   },
            ].map(r => (
              <div key={r.label} style={{ marginBottom:14 }}>
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:2 }}>
                  <span style={{ fontSize:13 }}>{r.icon}</span>
                  <span style={{ fontSize:12, color:T.muted }}>{r.label}</span>
                </div>
                <p style={{ margin:"0 0 0 21px", fontSize:13, color:T.text, fontWeight:500 }}>{r.val}</p>
              </div>
            ))}
          </div>
        </div>
        <RevenueChart/>
      </div>*/}
      <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:14 }}>
          <span style={{ fontSize:14, fontWeight:600, color:T.text }}>Orders</span>
          <span style={{ fontSize:12, color:T.accent, cursor:"pointer" }}>More →</span>
        </div>
        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
          <thead>
            <tr>{["Orders","Customers","Qty","Date","Revenue","Net Profit","Status","Actions"].map(h=>(
              <th key={h} style={{ textAlign:"left", color:T.faint, fontWeight:500, paddingBottom:12, borderBottom:`1px solid ${T.border}` }}>{h}</th>
            ))}</tr>
          </thead>
          <tbody>
            {PRODUCT_ORDERS.map((r,i)=>(
              <tr key={i} style={{ borderBottom:`1px solid ${T.border}` }}>
                <td style={{ padding:"12px 0", color:T.muted, fontSize:12 }}>{r.id}</td>
                <td><div style={{ display:"flex", alignItems:"center", gap:8 }}><Avatar name={r.customer} size={28}/><span style={{ color:T.text }}>{r.customer}</span></div></td>
                <td style={{ color:T.muted }}>{r.qty}</td>
                <td style={{ color:T.muted }}>{r.date}</td>
                <td style={{ color:T.text, fontWeight:500 }}>{r.rev}</td>
                <td style={{ color:T.muted }}>{r.profit}</td>
                <td><span style={{ color:statusColor(r.status), fontWeight:600 }}>{r.status}</span></td>
                <td><ActionBtns/></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ─── PAGE: CUSTOMERS ──────────────────────────────────────────────────────────
function CustomersPage() {
  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
        <h1 style={{ margin:0, fontSize:22, fontWeight:700 }}>
          <span style={{ color:T.accent }}>Customers</span>
          
        </h1>
      </div>
      <div style={{ display:"flex", gap:14, marginBottom:20, flexWrap:"wrap" }}>
        {PRODUCT_STATS.map(s => <StatCard key={s.label} {...s}/>)}
      </div>
      {/*
      <div style={{ display:"grid", gridTemplateColumns:"300px 1fr", gap:14, marginBottom:20 }}>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:24 }}>
          <div style={{ display:"flex", flexDirection:"column", alignItems:"center", marginBottom:20 }}>
            <div style={{ width:72, height:72, borderRadius:"50%", background:`${T.accent}22`, border:`2px solid ${T.accentBorder}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:28, marginBottom:12 }}>👨‍💼</div>
            <p style={{ margin:"0 0 2px", fontSize:15, fontWeight:700, color:T.text }}>Connie Robertson</p>
            <p style={{ margin:0, fontSize:12, color:T.muted }}>victoriasimmmons@2020.com</p>
          </div>
          <div style={{ borderTop:`1px solid ${T.border}`, paddingTop:16 }}>
            {[
              { icon:"👥", label:"Group",         val:"9,520"                              },
              { icon:"📍", label:"Location",      val:"Undefined, Minnesota 40 United States." },
              { icon:"📅", label:"First Order",   val:"September 30, 2019 1:49 PM"         },
              { icon:"🛒", label:"Latest Orders", val:"February 14, 2020 7:52 AM"          },
            ].map(r=>(
              <div key={r.label} style={{ marginBottom:14 }}>
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:2 }}>
                  <span style={{ fontSize:13 }}>{r.icon}</span>
                  <span style={{ fontSize:12, color:T.muted }}>{r.label}</span>
                </div>
                <p style={{ margin:"0 0 0 21px", fontSize:13, color:T.text, fontWeight:500, lineHeight:1.4 }}>{r.val}</p>
              </div>
            ))}
          </div>
        </div>
        <RevenueChart/>
      </div>*/}
     <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
  <div style={{ display:"flex", justifyContent:"space-between", marginBottom:14 }}>
    <span style={{ fontSize:14, fontWeight:600, color:T.text }}>Orders</span>
    <span style={{ fontSize:12, color:T.accent, cursor:"pointer" }}>More →</span>
  </div>

  <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
    <thead>
      <tr>
        {["Customer","Order ID","Product","Qty","Date","Revenue","Net Profit","Status","Actions"].map(h => (
          <th key={h} style={{ textAlign:"left", color:T.faint, fontWeight:500, paddingBottom:12, paddingRight:14, borderBottom:`1px solid ${T.border}`, whiteSpace:"nowrap" }}>
            {h}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {CUSTOMER_ORDERS.map((r, i) => (
        <tr key={i} style={{ borderBottom:`1px solid ${T.border}` }}>

          {/* Customer */}
          <td style={{ padding:"12px 14px 12px 0" }}>
            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
              <div style={{
                width:28, height:28, borderRadius:"50%",
                background:r.color, color:r.tcolor,
                display:"flex", alignItems:"center", justifyContent:"center",
                fontSize:11, fontWeight:600, flexShrink:0
              }}>
                {r.initials}
              </div>
              <span style={{ fontWeight:500, color:T.text, fontSize:13 }}>{r.customer}</span>
            </div>
          </td>

          {/* Order ID */}
          <td style={{ padding:"12px 14px 12px 0", color:T.muted, fontSize:12 }}>{r.id}</td>

          {/* Product */}
          <td style={{ padding:"12px 14px 12px 0" }}>
            <p style={{ margin:0, color:T.text, fontWeight:500 }}>{r.product}</p>
            <p style={{ margin:0, fontSize:11, color:T.faint }}>{r.cat}</p>
          </td>

          {/* Qty */}
          <td style={{ padding:"12px 14px 12px 0", color:T.muted }}>{r.qty}</td>

          {/* Date */}
          <td style={{ padding:"12px 14px 12px 0", color:T.muted }}>{r.date}</td>

          {/* Revenue */}
          <td style={{ padding:"12px 14px 12px 0", color:T.text, fontWeight:500 }}>{r.rev}</td>

          {/* Net Profit */}
          <td style={{ padding:"12px 14px 12px 0", color:T.muted }}>{r.profit}</td>

          {/* Status */}
          <td style={{ padding:"12px 14px 12px 0" }}>
            <span style={{
              fontSize:11, fontWeight:500, padding:"3px 9px", borderRadius:20,
              background:statusBg(r.status), color:statusColor(r.status),
              display:"inline-block"
            }}>
              {r.status}
            </span>
          </td>

          {/* Actions */}
          <td style={{ padding:"12px 0" }}><ActionBtns /></td>

        </tr>
      ))}
    </tbody>
  </table>
</div>
    </div>
  );
}

/*─── PAGE: ANALYTICS ──────────────────────────────────────────────────────────
function AnalyticsPage() {
  const monthData = [
    {m:"Jan",rev:7825,orders:920,visitors:15500},
    {m:"Feb",rev:9200,orders:1100,visitors:18000},
    {m:"Mar",rev:8400,orders:980, visitors:16200},
    {m:"Apr",rev:11000,orders:1350,visitors:21000},
    {m:"May",rev:9800,orders:1200,visitors:19500},
    {m:"Jun",rev:12500,orders:1500,visitors:24000},
  ];
  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
        <h1 style={{ margin:0, fontSize:22, fontWeight:700, color:T.text }}>Analytics</h1>
      </div>
      <div style={{ display:"flex", gap:14, marginBottom:20, flexWrap:"wrap" }}>
        {DASHBOARD_STATS.map(s => <StatCard key={s.label} {...s}/>)}
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:20 }}>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
          <p style={{ margin:"0 0 16px", fontSize:14, fontWeight:600, color:T.text }}>Revenue Trend</p>
          <ResponsiveContainer width="100%" height={200}>
            <AreaChart data={monthData}>
              <defs>
                <linearGradient id="rg" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%"  stopColor={T.accent} stopOpacity={0.3}/>
                  <stop offset="95%" stopColor={T.accent} stopOpacity={0}/>
                </linearGradient>
              </defs>
              <CartesianGrid stroke={T.border} strokeDasharray="3 3"/>
              <XAxis dataKey="m" tick={{fill:T.faint,fontSize:11}} axisLine={false} tickLine={false}/>
              <YAxis tick={{fill:T.faint,fontSize:11}} axisLine={false} tickLine={false}
                tickFormatter={v=>`$${(v/1000).toFixed(0)}k`}/>
              <Tooltip content={<CustomTooltip/>}/>
              <Area type="monotone" dataKey="rev" stroke={T.accent} strokeWidth={2.5}
                fill="url(#rg)" dot={false}/>
            </AreaChart>
          </ResponsiveContainer>
        </div>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
          <p style={{ margin:"0 0 16px", fontSize:14, fontWeight:600, color:T.text }}>Orders vs Visitors</p>
          <ResponsiveContainer width="100%" height={200}>
            <LineChart data={monthData}>
              <CartesianGrid stroke={T.border} strokeDasharray="3 3"/>
              <XAxis dataKey="m" tick={{fill:T.faint,fontSize:11}} axisLine={false} tickLine={false}/>
              <YAxis tick={{fill:T.faint,fontSize:11}} axisLine={false} tickLine={false}/>
              <Tooltip content={<CustomTooltip/>}/>
              <Line type="monotone" dataKey="orders"   stroke={T.orange} strokeWidth={2.5} dot={false}/>
              <Line type="monotone" dataKey="visitors" stroke={T.blue}   strokeWidth={2.5} dot={false}/>
            </LineChart>
          </ResponsiveContainer>
          <div style={{ display:"flex", gap:16, marginTop:8, fontSize:12 }}>
            <span style={{ display:"flex", alignItems:"center", gap:6 }}>
              <span style={{ width:10, height:2, background:T.orange, display:"inline-block" }}/>
              <span style={{ color:T.muted }}>Orders</span>
            </span>
            <span style={{ display:"flex", alignItems:"center", gap:6 }}>
              <span style={{ width:10, height:2, background:T.blue, display:"inline-block" }}/>
              <span style={{ color:T.muted }}>Visitors</span>
            </span>
          </div>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
          <p style={{ margin:"0 0 16px", fontSize:14, fontWeight:600, color:T.text }}>Traffic by Device</p>
          <div style={{ display:"flex", alignItems:"center", gap:20 }}>
            <ResponsiveContainer width={140} height={140}>
              <PieChart>
                <Pie data={DEVICE_DATA} cx="50%" cy="50%" innerRadius={42} outerRadius={65}
                  dataKey="value" startAngle={90} endAngle={-270}>
                  {DEVICE_DATA.map((d,i)=><Cell key={i} fill={d.color}/>)}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div style={{ flex:1 }}>
              {DEVICE_DATA.map(d=>(
                <div key={d.name} style={{ display:"flex", justifyContent:"space-between", marginBottom:8, fontSize:12 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                    <span style={{ width:8,height:8,borderRadius:"50%",background:d.color,display:"inline-block"}}/>
                    <span style={{ color:T.muted }}>{d.name}</span>
                  </div>
                  <span style={{ color:T.faint }}>{d.value}%</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, padding:20 }}>
          <p style={{ margin:"0 0 16px", fontSize:14, fontWeight:600, color:T.text }}>Sales Forecast</p>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
            {FORECAST.map(f=>(
              <div key={f.label} style={{ background:T.cardAlt, borderRadius:10, padding:"14px 16px", border:`1px solid ${T.border}` }}>
                <p style={{ margin:"0 0 6px", fontSize:11, color:T.muted }}>{f.label}</p>
                <p style={{ margin:0, fontSize:20, fontWeight:700, color:f.up?T.accent:T.red }}>{f.val}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
*/
// ─── APP SHELL ────────────────────────────────────────────────────────────────
export default function App() {
  const [active, setActive] = useState("dashboard");

  const pages = {
    dashboard: <DashboardPage/>,
    orders:    <OrdersPage/>,
    products:  <ProductsPage/>,
    customers: <CustomersPage/>,
    //analytics: <AnalyticsPage/>,
  };

  return (
    <div style={{ display:"flex", height:"100vh", background:T.bg, fontFamily:"system-ui, -apple-system, sans-serif", overflow:"hidden" }}>
      {/* Sidebar */}
      <div style={{
        width:200, background:T.sidebar, borderRight:`1px solid ${T.border}`,
        display:"flex", flexDirection:"column", padding:"24px 0", flexShrink:0,
      }}>
        <div style={{ padding:"0 20px 24px", borderBottom:`1px solid ${T.border}` }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ width:32, height:32, borderRadius:8, background:T.accentDim, border:`1px solid ${T.accentBorder}`, display:"flex", alignItems:"center", justifyContent:"center" }}>
              <span style={{ color:T.accent, fontSize:16, fontWeight:700 }}>S</span>
            </div>
            <span style={{ color:T.text, fontWeight:700, fontSize:15 }}>SportsKit</span>
          </div>
        </div>
        <nav style={{ padding:"16px 12px", flex:1 }}>
          {NAV.map(n => (
            <div key={n.key}
              onClick={() => setActive(n.key)}
              style={{
                display:"flex", alignItems:"center", gap:10,
                padding:"10px 12px", borderRadius:8, marginBottom:2, cursor:"pointer",
                background: active===n.key ? T.accentDim : "transparent",
                border: active===n.key ? `1px solid ${T.accentBorder}` : "1px solid transparent",
                color: active===n.key ? T.accent : T.muted,
                fontWeight: active===n.key ? 600 : 400, fontSize:13,
                transition:"all 0.15s",
              }}
            >
              <span style={{ fontSize:15 }}>{n.icon}</span>
              {n.label}
            </div>
          ))}
        </nav>
      </div>

      {/* Main content */}
      <div style={{ flex:1, overflowY:"auto", padding:28 }}>
        {pages[active] || <DashboardPage/>}
      </div>
    </div>
  );
}